import script from "./TheCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./TheCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./TheCheckbox.vue?vue&type=style&index=0&id=3c702f4c&scoped=true&lang=css"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\161\\s\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c702f4c"]])

export default __exports__